import getLang from 'I18n/utils/getLang';
import { AppContextType } from 'marketplace-ui-common/types';
import { ProductType } from 'marketplace-ui-common/types/products';
import {
  CombosResponse,
  ScopesRequest,
} from '../../__generated__/chirp/com/hubspot/scopegaps/rpc/ScopeGapsService';
import { useGetSatisfyingCombosBatchQuery } from '../../__generated__/chirp/com/hubspot/scopegaps/rpc/ScopeGapsService.hooks';
import { UnifiedDetailsFeature } from 'marketplace-ui-common/types/index';

interface UseFeatureCompatibilitiesProps {
  appContext: AppContextType;
  features: UnifiedDetailsFeature[];
  productType: ProductType;
}

export function useFeatureCompatibilities({
  appContext,
  features,
  productType,
}: UseFeatureCompatibilitiesProps) {
  const isPublic = appContext === 'public';
  const isAdminPreview = appContext === 'admin-preview';

  const filteredFeatures =
    productType !== 'APP'
      ? features //skip check for featureLocation for non-apps
      : features.filter((feature: UnifiedDetailsFeature) => {
          return (
            feature?.featureLocation?.includes('MARKETPLACE_LISTING') ?? false
          );
        });

  const requestPayloads: ScopesRequest[] = [];

  filteredFeatures.forEach((feature) => {
    const scopes =
      feature.featureInternalScopes
        ?.filter((scope: string) => scope !== '')
        .map((scope: string) => scope.replaceAll('_', '-').toLowerCase()) || [];
    const scopeGroups =
      feature.featureScopeGroups?.filter(
        (scopeGroup: string) => scopeGroup !== ''
      ) || [];

    requestPayloads.push({
      frontendLocale: getLang(),
      minimal: true,
      scopes,
      scopeGroups,
    });
  });

  const { data, loading, error } = useGetSatisfyingCombosBatchQuery({
    variables: {
      requests: requestPayloads,
    },
    skip: isPublic || filteredFeatures.length === 0 || isAdminPreview,
  });

  const result: Record<string, CombosResponse> = {};

  data?.results.forEach((featureData, index) => {
    if (index < filteredFeatures.length) {
      result[filteredFeatures[index].featureName] = featureData;
    }
  });

  return { result, loading, error };
}
